import React, { useContext, useEffect, useState } from "react";
import { MainContainer, StyledDashboard } from "./dashboard.style";
import Stats from "./fixelStats/Stats";

import FixelDataContext from "../../context/FixelDataContext";
import Notifications from "./notifications/Notifications";
import { Link } from "react-router-dom";
import LearnMoreFBIntMsg from "./FBAudiences/LearnMoreFBIntMsg";

const Dashboard = () => {

  const { fullFixelData } = useContext(FixelDataContext);
  const [haveData, setHaveData] = useState(false);

  useEffect(() => {
    let didCancel = false;
    const showDashboard = () => {
      if (!didCancel && fullFixelData && fullFixelData.code) {
        setHaveData(true);
      }
    };
    showDashboard();
    return () => {
      didCancel = true;
    };
  }, [fullFixelData]);

  const renderDashboard = () => {
    if (!haveData) {
      return (
        <p>
          no data to show here yet. you can try to go back to the
          <Link to="/introduction"> installation page</Link>
        </p>
      );
    } else {
      return (
        <>
          <Notifications />
          <Stats />
          {/* <Audiences /> suppressed while FB app not approved */}
          {/* <Audiences /> */}
          <LearnMoreFBIntMsg />
        </>
      );
    }
  };

  return (
    <StyledDashboard>
      <MainContainer>{renderDashboard()}</MainContainer>
    </StyledDashboard>
  );
};
export default Dashboard;
